import type { SelectProps } from 'antd'
import { Select } from 'antd'
import type {
  FilterOption,
  ResolvedFilter,
} from 'features/libra/dashboard/ticketDashboard/filtering/applyFilters'
import type { FC } from 'react'
import { memo, useCallback } from 'react'
import styled from 'styled-components'

const NO_VALUES: ReadonlyArray<string> = []

/** Fills its filter-bar cell; selected values collapse to "+N" when they don't fit. */
const FilterSelect = styled(Select<ReadonlyArray<string>, FilterOption>)`
  width: 100%;
`

interface SelectFilterProps {
  filter: ResolvedFilter
  value: ReadonlyArray<string> | undefined
  onChange: (category: string, values: ReadonlyArray<string>) => void
}

/**
 * Counts render only in the dropdown. Keeping them out of `label` keeps the
 * selected values the same width as counts change, which stops the field reflowing.
 */
const renderOption: SelectProps<
  ReadonlyArray<string>,
  FilterOption
>['optionRender'] = (option) => `${option.data.label} (${option.data.count})`

const RawSelectFilter: FC<SelectFilterProps> = ({
  filter,
  value = NO_VALUES,
  onChange,
}) => {
  const handleChange = useCallback(
    (next: ReadonlyArray<string>) => onChange(filter.category, next),
    [onChange, filter.category]
  )

  return (
    <FilterSelect
      mode='multiple'
      allowClear
      placeholder={filter.label}
      value={value}
      options={filter.options}
      optionRender={renderOption}
      onChange={handleChange}
      maxTagCount='responsive'
      popupMatchSelectWidth={false}
    />
  )
}

export const SelectFilter = memo(RawSelectFilter)
